import React, { useState } from 'react';
import { RequireOrg, VpState } from '../components/VelopulseShell';
import { vpApi, errorMessage } from '../api/velopulse';

function DeedCard({ deed, emptyText }) {
  if (!deed) return <VpState text={emptyText} />;
  const m = deed.marker || {};
  return (
    <div>
      <div className="vp-detail-head">
        <h1>{deed.kind_label}</h1>
        <span className="vp-badge indigo">{m.number_label} {m.number}</span>
      </div>
      <p className="vp-sub" style={{ margin: '0 0 12px' }}>
        {m.city}{m.district} {m.section}
      </p>
      {(deed.sections || []).map((sec) => (
        <div key={sec.key} style={{ marginBottom: 16 }}>
          <h3 style={{ margin: '0 0 4px', fontSize: 14 }}>{sec.title}</h3>
          <div className="vp-fields">
            {(sec.rows || []).map(([k, v]) => (
              <div className="vp-kv" key={k}><div className="k">{k}</div><div className="v">{v}</div></div>
            ))}
          </div>
        </div>
      ))}
      {deed.is_mock && <p className="vp-disclaimer">{deed.disclaimer}</p>}
    </div>
  );
}

function RealtyTitleDeed() {
  const [address, setAddress] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await vpApi.lookupTitleDeed({ address: address.trim() });
      setResult(data);
    } catch (err) {
      setResult(null);
      setError(errorMessage(err, '謄本查詢失敗，請稍後再試。'));
    } finally {
      setLoading(false);
    }
  };

  const emptyHint = '輸入門牌地址後按「調謄本」，土地與建物示範謄本會顯示在這裡。';

  return (
    <div className="vp-content wide vp-search">
      <div className="vp-hello">
        <div>
          <h1>調謄本</h1>
          <p>
            輸入門牌地址即可同時查詢土地與建物示範謄本；不需建號或地號。
            目前為示範資料模式。
          </p>
        </div>
      </div>

      <div className="vp-warnbox" role="note">
        正式謄本請透過地政資訊服務網付費申請、地政事務所臨櫃或委任地政士取得；本系統不對地政網站進行自動化抓取。
      </div>

      <form className="vp-card vp-search-filters" onSubmit={submit}>
        <div className="vp-bar" style={{ marginBottom: 0 }}>
          <input
            style={{ flex: 1, minWidth: 240 }}
            placeholder="例：臺北市大安區忠孝東路四段 100 號"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            aria-label="門牌地址"
            autoComplete="street-address"
          />
          <button type="submit" className="vp-btn primary" disabled={loading}>
            {loading ? '查詢中…' : '調謄本'}
          </button>
        </div>
      </form>

      {error && (
        <div className="vp-card" style={{ marginTop: 12 }}>
          <VpState text={error} />
        </div>
      )}
      {!error && (
        <div style={{ marginTop: 12, display: 'grid', gap: 12 }}>
          {loading ? (
            <div className="vp-card"><VpState loading /></div>
          ) : (
            <>
              <div className="vp-card">
                <DeedCard deed={result?.land} emptyText={emptyHint} />
              </div>
              <div className="vp-card">
                <DeedCard
                  deed={result?.building}
                  emptyText={result?.land ? '建物示範謄本載入中或查無資料。' : emptyHint}
                />
              </div>
            </>
          )}
          {result?.is_mock && result?.disclaimer && (
            <p className="vp-disclaimer" style={{ margin: '0 4px' }}>{result.disclaimer}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default function RealtyTitleDeedPage() {
  return <RequireOrg><RealtyTitleDeed /></RequireOrg>;
}
